import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${Spacing.S8};
  padding: ${Spacing.S16} 12px;
`

export const Illustration = styled.div`
  display: block;
  width: 180px;
  max-width: 100%;

  > svg {
    display: block;
    width: 100%;
    height: auto;
  }
`
